<script lang="ts">
  import type { Place } from "../types";
  import Sprite from "./sprite.svelte";
  import Translate from "./locale.svelte";
  import { getStatus, getStatusNote, isClosedStatus } from "../domain/status";
  import { placePath, type QueryParams } from "../support/links";
  import { createEventDispatcher } from "svelte";
  import { getNow } from "../data/clock";

  export let time = getNow();
  export let place: Place;
  export let linkBuilder: (query?: QueryParams) => string;

  const dispatch = createEventDispatcher();

  function onNavigate() {
    dispatch("navigate");
  }

  $: status = getStatus(place, $time);
  $: statusNote = getStatusNote(place, $time);
  $: closed = isClosedStatus(status);
  $: closeHref = linkBuilder();
  $: href = placePath(place);
</script>

<section class="Wrapper" class:statusNote class:closed>
  {#if closed || statusNote}
    <div class="Status">
      {#if closed}
        <div class="type-subtitle-1">
          <b><Translate label="status.{status}" /></b>
        </div>
      {/if}

      {#if statusNote}
        <div class="type-body-2">{statusNote}</div>
      {/if}
    </div>
  {/if}

  <div class="Banner">
    <h2 class="Title">
      <a class="CloseBtn" href={closeHref}>
        <Sprite icon="icon-close" />
        <span class="sr-only">Close</span>
      </a>

      <a class="TitleLink" {href} on:click={onNavigate}>
        {place.title}
        <Sprite icon="icon-chevron-right" />
      </a>
    </h2>
  </div>
</section>

<style>
  .Wrapper {
    --inset: 8px;
    left: 0;
    padding-bottom: var(--inset);
    padding-left: max(env(safe-area-inset-left, 0px), var(--inset));
    padding-right: max(env(safe-area-inset-right, 0px), var(--inset));
    padding-top: max(env(safe-area-inset-top, 0px), var(--inset));
    position: absolute;
    right: 0;
    top: 0;
    z-index: 10;
  }

  .Wrapper.statusNote {
    background-color: rgb(0, 0, 0, 60%);
  }

  .Wrapper.closed {
    background-color: rgb(143, 67, 0, 95%);
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  }

  .Banner {
    border-radius: var(--border-radius-large);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.24);
  }

  .Title {
    border-radius: inherit;
    display: flex;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0.08em;
    line-height: 1;
    overflow: hidden;
    margin: 0;
  }

  .TitleLink {
    background: white;
    align-items: center;
    display: flex;
    flex: 1 1;
    justify-content: space-between;
    min-height: 40px;
    padding: 0 8px 0 12px;
    text-decoration: none;
  }

  .CloseBtn {
    border-top-left-radius: inherit;
    border-bottom-left-radius: inherit;
    background: black;
    display: block;
    flex: 0 0;
    color: white;
    padding: 12px;
  }

  .Status {
    color: white;
    text-align: center;
    padding: 8px 0 16px;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  }
</style>
